import styled from '@emotion/styled';

const ErrorMessageWrapper = styled('div')({
  height: 0,
  overflow: 'visible',
  position: 'relative',
});

export default ErrorMessageWrapper;
